import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { SignedByLengths } from './form-max-lengths';

const ALLOWED_PATTERN = /^[\p{L} .'\-]+$/u;

export function signatureNameValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const raw = control.value;
        if (raw == null || raw === '') return null;

        const value = String(raw);
        const errors: ValidationErrors = {};

        if (value.length < SignedByLengths.Min) {
            errors['minlength'] = { requiredLength: SignedByLengths.Min, actualLength: value.length };
        }

        if (value.length > SignedByLengths.Max) {
            errors['maxlength'] = { requiredLength: SignedByLengths.Max, actualLength: value.length };
        }

        if (!ALLOWED_PATTERN.test(value)) {
            errors['signatureCharacters'] = true;
        }

        return Object.keys(errors).length > 0 ? errors : null;
    };
}

export const SIGNATURE_INVALID_CHARS_MESSAGE =
    "Signature can only contain letters, spaces, hyphens, periods and apostrophes.";
